import { render, staticRenderFns } from "./order-scan.vue?vue&type=template&id=63d1e4f7&scoped=true&"
import script from "./order-scan.vue?vue&type=script&lang=ts&"
export * from "./order-scan.vue?vue&type=script&lang=ts&"
import style0 from "./order-scan.vue?vue&type=style&index=0&id=63d1e4f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d1e4f7",
  null
  
)

export default component.exports